import { render } from "./AppLayoutPrivateVertical.vue?vue&type=template&id=507d9bfc"
import script from "./AppLayoutPrivateVertical.vue?vue&type=script&lang=js"
export * from "./AppLayoutPrivateVertical.vue?vue&type=script&lang=js"

import "./AppLayoutPrivateVertical.vue?vue&type=style&index=0&id=507d9bfc&lang=scss"

import exportComponent from "/Users/carloslazcanoyoung/PROJECT/MUSS/COMPANY/SOFOFA/IEE/iee-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__